import React from 'react';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import ConversationInteractionPerformance from 'components/OnDemandPractice/Creator/OnDemandPracticeOverview/ConversationInteractionPerformance';
import CompletionsByUserTable from './CompletionsByUserTable';

function ConversationOverview({
  lessonOverviewUrl,
  lessonTitle,
  lessonId,
  question,
  conversationTitle,
  groupId,
}) {
  return (
    <div className="panel question">
      <header>
        <Text variant={TEXT_VARIANTS.INSTRUX_SEMIBOLD}>
          {t('lesson_performance.for') + ' '}
          <a className="decorated" href={lessonOverviewUrl}>
            {lessonTitle}
          </a>
        </Text>
      </header>
      <div>
        <Text variant={TEXT_VARIANTS.TITLE}>{conversationTitle}</Text>
      </div>
      <div>
        <ConversationInteractionPerformance
          question={question}
          groupId={groupId}
        />
      </div>
      <div>
        <CompletionsByUserTable
          question={question}
          lessonId={lessonId}
          groupId={groupId}
        />
      </div>
    </div>
  );
}

export default props => <ConversationOverview {...props} />;
